export const studentFormApiEndpoints = {
  formLoad: '../api/form/load',
  adLogin: '../api/form/login',
  editSubmission: '../api/form/submission/edit',
  submitApplication: '../api/form/submission/submit',
  institutionList: '../api/public/institution/list',
  subjectSearch: '../api/form/subject/search',
  fileUpload: '../api/form/file/upload',
} as const

export type StudentFormApiEndpointKey = keyof typeof studentFormApiEndpoints

export type StudentFormApiEndpoint = (typeof studentFormApiEndpoints)[StudentFormApiEndpointKey]
